<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_ReasonOfCargoDetention')"
      width="300px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <div>
          <div class="form-row" style="display: flex">
            <div style="margin: auto;width: 25%">
              <span>{{ $t('CargoMsg.Cargo_ReasonOfCargoDetentionP') }}</span>
            </div>
            <div style="width: 75%">
              <el-input
                v-model="remark"
                no="remark"
                type="textarea"
                :rows="5"
                style="width:200px"
              />
            </div>
          </div>
        </div>
        <div class="spacing" />
        <div class="triggers" align="right">
          <el-button no="confirm" type="primary" @click="selectedHandler">
            {{ $t('common.btn.confirm') }}
          </el-button>

          <el-button no="close" type="primary" @click="cancel">
            {{ $t('common.btn.close') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'WithholdReasonWindow',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    list: { type: Array, require: true }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      remark: ''
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {

  },
  mounted() {

  },
  methods: {
    cancel() {
      this.remark = ''
      this.$emit('update:visible', false)
    },
    selectedHandler() {
      this.$emit('saveWithholdReasonHandler', { remark: this.remark, list: this.list })
      this.remark = ''
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}

.spacing {
  padding-top: 20px;
}
</style>

